import React from "react";
// import CourseOverview from "../section-component/course-overview/CourseOverview";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import WhatYouLearn from "../section-component/what-you-learn/WhatYouLearn";
import BatchTimings from "../section-component/batch-timing/BatchTimings";
import WhoShouldEnroll from "../section-component/who-enroll/WhoShouldEnroll";
import MentorsFaculty from "../section-component/mentor-faculty/MentorsFaculty";
import CallToAction from "../section-component/call-to-action/CallToAction";
import StudentReviews from "../section-component/student-review/StudentReviews";
import LiveChat from "../section-component/live-chat/LiveChat";
import CourseHeroSection from "./course-hero-section/CourseHeroSection";
import CourseOverview from "./course-overview/CourseOverview";
import CurriculumSection from "./curriculam-section/CurriculumSection";
import ScheduleSection from "./schedule-section/ScheduleSection";
import CourseEnrollCTA from "./course-cta/CourseEnrollCTA";
import FeeStructure from "./fee-structure/FeeStructure";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const CourseOverviewIndex = () => {
    return (
        <>
            
             
            <CourseHeroSection />
            <CourseOverview />
            <CurriculumSection />
            {/* <ScheduleSection /> */}
            <FeeStructure />
            <CourseEnrollCTA />
            <WhatYouLearn />
            <BatchTimings />
            <WhoShouldEnroll />
            <MentorsFaculty />
            <StudentReviews />
            <CallToAction />

            
        </>
    );
};

export default CourseOverviewIndex;